import { SharedModule } from 'src/app/shared/shared.module'

import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'

import { CompetitionPoolEffects } from './competition-pool.effects'
import * as fromCompetitionPool from './competition-pool.reducer'
import { CompetitionPoolSerializer } from './competition-pool.serializer'
import { CompetitionPoolService } from './competition-pool.service'

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    StoreModule.forFeature(
      fromCompetitionPool.FEATURE_NAME,
      fromCompetitionPool.competitionPoolReducer
    ),
    EffectsModule.forFeature([CompetitionPoolEffects])
  ],
  providers: [
    CompetitionPoolService,
    {
      provide: CompetitionPoolSerializer,
      useClass: CompetitionPoolSerializer
    }
  ],
  declarations: []
})
export class CompetitionPoolModule {}
